import { action } from 'typesafe-actions'
import { types } from './types'

export const updateFormData = (payload: any) =>
  action(types.UPDATE_FORMDATA, payload)
export const imagesDialog = () => action(types.OPEN_IMAGES)
export const stylesheetsDialog = () => action(types.OPEN_STYLESHEET)
